<route>
{
    "name": "admin-role-edit",
    "meta": {
        "title": "Actualizare rol",
        "requiresAuth": true,
        "permissions": ["manager", "sef_de_unitate"],
        "fail": "/403"
    }
}
</route>
<template>
    <modal-layout class="white">
        <v-card :flat="true">
            <v-toolbar class="primary">
                <v-btn
                    icon
                    color="white"
                    @click.native="redirectBack()"
                >
                    <v-icon>arrow_back</v-icon>
                </v-btn>
                <v-toolbar-title class="text-xs-center white--text">
                    Actualizare rol
                </v-toolbar-title>
            </v-toolbar>
            <v-layout row wrap my-5>
                <v-flex xs12 md10 offset-md1 px-2>
                    <manage :id="modelId"></manage>
                </v-flex>
            </v-layout>
        </v-card>
    </modal-layout>
</template>

<script>
    import ModalLayout from "Layouts/ModalLayout.vue";
    import Manage from "Components/users-and-roles/ManageRole.vue";

    export default {
        components: {
            ModalLayout,
            Manage
        },
        methods: {
            redirectBack() {
                let self = this;
                self.$nextTick(() => self.$nextTick(() => self.$router.go(-1)));
            }
        },
        computed: {
            modelId () {
                return this.$route.params?.id
            }
        }
    };
</script>
